import { MutableRefObject, useContext } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { getConfig } from "../../config";
import { ColorContext } from "../../context/ColorContext";
import { GoogleServicesContext } from "../../context/GoogleServicesContext";
import { LanguageContext } from "../../context/LanguageContext";

type GoogleRecaptchaProps = {
  recaptchaRef: MutableRefObject<ReCAPTCHA | null>;
};

const GoogleRecaptcha = ({ recaptchaRef }: GoogleRecaptchaProps) => {
  const language = useContext(LanguageContext);
  const colorMode = useContext(ColorContext);
  const { neccessaryCookiesAllowed } = useContext(GoogleServicesContext);
  const siteKey = getConfig().RECAPTCHA_SITE_KEY;

  return (
    // Only load recaptcha if the user has accepted the necessary cookies
    neccessaryCookiesAllowed ? (
      <ReCAPTCHA
        key={language.selectedLanguage}
        style={{ position: "absolute" }}
        theme={colorMode.selectedMode}
        ref={recaptchaRef}
        size="invisible"
        hl={language.selectedLanguage} // https://developers.google.com/recaptcha/docs/language
        badge="bottomleft"
        sitekey={siteKey ?? ""}
        onErrored={() => console.log("Recaptcha error")}
        onExpired={() => console.log("Recaptcha expired")}
      />
    ) : (
      <></>
    )
  );
};

export default GoogleRecaptcha;
